import { Box, Chip, Typography } from '@mui/material';

import { ReactComponent as VerticalDotsIcon } from 'assets/vertical-dots.svg';
import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import { BusinessType } from 'store/slices/businessesSlice';
import Logo from '../Logo';
import style from './style.module.css';
import styles, { primary, secondary } from './styles';
import { statisticsData, widgetValue } from './utils';

const Card = ({
  data,
  onSettingsClick,
}: {
  data: BusinessType;
  onSettingsClick: (e: MouseEvent<SVGSVGElement>, id: string) => void;
}) => {
  const { businessId, name, logoUrl, category, activeDealCount, wonValue, successRate, industry } =
    data;

  return (
    <Box
      sx={styles.cardContainer}
      component={Link}
      to={`${RoutePaths.Businesses}/${businessId}`}
      key={businessId}
    >
      <Box sx={styles.header}>
        <Box sx={styles.metaData}>
          <Box sx={styles.logo}>
            <Logo logo={logoUrl} />
          </Box>
          <Box sx={styles.title}>
            <Typography variant='responsiveHeading4'>{name}</Typography>
            <Box sx={styles.chipsContainer}>
              <Chip sx={{ ...primary }} label={category} />
              <Chip sx={{ ...secondary }} label={industry} />
            </Box>
          </Box>
        </Box>
        <Box sx={styles.optionMenu}>
          <VerticalDotsIcon
            className={style['vertical-icon']}
            onClick={(e: MouseEvent<SVGSVGElement>) => {
              e.preventDefault();
              onSettingsClick(e, businessId);
            }}
          />
        </Box>
      </Box>
      <Box sx={styles.widgetContainer}>
        {statisticsData(activeDealCount, wonValue, successRate).map(
          ({ value, formattedValue, label }) => {
            const widgetValueStyles = label === 'Success Rate' ? widgetValue(value) : {};

            return (
              <Box sx={styles.widget} key={label}>
                <Typography sx={{ ...widgetValueStyles }} variant='buttonMedium'>
                  {formattedValue}
                </Typography>
                <Typography>{label}</Typography>
              </Box>
            );
          },
        )}
      </Box>
    </Box>
  );
};

export default Card;
